module.exports = __webpack_public_path__ + "img/home-slide3-mobile-gr-2x.f1ed4bf1.png";